module.exports = new __parcel__URL__("moderna_logo.5f40215b.svg").toString();